import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import canteiroAreiaService, { CanteiroAreiaDetalhes } from '../../../../services/sementes/canteiroAreia';
import { selectTopBarState } from '../../../../components/Topbar/topBarSlice';

interface UseCanteiroAreiaDetalhesResult {
  detalhes: CanteiroAreiaDetalhes | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export default function useCanteiroAreiaDetalhes(id: string): UseCanteiroAreiaDetalhesResult {
  const [detalhes, setDetalhes] = useState<CanteiroAreiaDetalhes | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { currentProdutor } = useSelector(selectTopBarState);

  useEffect(() => {
    if (!id || !currentProdutor?.id) {
      setLoading(true);
      return;
    }

    const fetchDetalhes = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await canteiroAreiaService.getById(id, currentProdutor.id);
        setDetalhes(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro ao carregar detalhes');
        setDetalhes(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDetalhes();
  }, [id, currentProdutor?.id]);

  const refetch = useCallback(async () => {
    if (!id || !currentProdutor?.id) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await canteiroAreiaService.getById(id, currentProdutor.id);
      setDetalhes(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar detalhes');
      setDetalhes(null);
    } finally {
      setLoading(false);
    }
  }, [id, currentProdutor?.id]);

  return {
    detalhes,
    loading,
    error,
    refetch,
  };
}
